import { getFieldSlug } from "@smartsuite/fields-logic/lib/utils/fields";
import type { FieldParametersFormRenderer } from "@smartsuite/gridview/lib/components/GridView/components/FieldParametersForm/FieldParametersForm.types";
import type { GridViewAggregationRenderer } from "@smartsuite/gridview/lib/components/GridView/GridView.types";
import type { GridViewFieldRenderer } from "@smartsuite/gridview/lib/components/GridViewCell/GridViewCell.types";
import type { GridViewGroupFieldRenderer } from "@smartsuite/gridview/lib/components/GridViewGroup/GridViewGroup.types";
import { Text } from "@smartsuite/react-ui/lib";
import type { AppField, Preferences, Tag } from "@smartsuite/types";
import React from "react";

import type { BaseRecord } from "../../../../../../types/form";
import { getDisplayValue } from "../../../display-value/getFieldDisplayValue";

interface CreateGridViewFieldRendererDeps {
  fieldsToShow: Record<string, AppField>;
  tags?: Tag[];
  relatedRecords?: BaseRecord[];
  userPreferences?: Preferences;
}

export const createGridViewFieldRenderer = ({
  fieldsToShow,
  tags,
  relatedRecords,
  userPreferences,
}: CreateGridViewFieldRendererDeps): GridViewFieldRenderer => {
  // biome-ignore lint/correctness/noComponentHookFactories: the grid takes a renderer bound to this table's data; LinkedRecordTable memoizes it
  const GridViewFieldRendererComponent: GridViewFieldRenderer = ({ field, record }) => {
    const fieldSlug = getFieldSlug(field);
    const displayValue = getDisplayValue(
      record,
      fieldSlug,
      fieldsToShow,
      tags,
      relatedRecords,
      undefined,
      userPreferences,
    );

    return (
      <Text size="l" wrapMode="ellipsis" className="form-field-value">
        {displayValue}
      </Text>
    );
  };

  return GridViewFieldRendererComponent;
};

export const gridViewGroupRenderer: GridViewGroupFieldRenderer = () => <></>;

export const gridViewAggregationRenderer: GridViewAggregationRenderer = () => <></>;

export const fieldParametersFormRenderer: FieldParametersFormRenderer = () => <></>;
